import { pxToRem } from '../../../../utils';
export var dividerContentStyles = {
  root: function root() {
    return {
      marginLeft: pxToRem(20),
      marginRight: pxToRem(20)
    };
  }
};